/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { JSX } from "react"

import { forceHomeRedirect } from "../../utils/force-redirect"

export const AccessDeniedView = (): JSX.Element => {
    return (
        <div className="page-container">
            <div className="flex justify-between items-center">
                <h3 className="text-legacy-primary">{`Access Denied`}</h3>
            </div>

            <div className="mt-6 mb-6">
                <div className="page-container my-6">
                    <p>You do not have the required permissions to access this page.</p>
                    <p>Please contact your administrator if you require additional access privileges.</p>
                    <button className="btn btn btn-primary mt-6" onClick={() => forceHomeRedirect()}>
                        Go to Dashboard
                    </button>
                </div>
            </div>
        </div>
    )
}
